<template>
  <a
    tabindex="0"
    class="tgmag-btn"
    :class="[
      buttonClasses,
      { 'tgmag-btn--loading': loading },
      { 'tgmag-btn--disabled': isDisabled }
    ]"
    @click="onClick"
  >
    <slot />
    <spinner v-if="loading" class="tgmag-btn__spinner" role="status" />
  </a>
</template>

<script>
import Spinner from "../Spinner";

export default {
  name: "TransfersButton",
  components: { Spinner },
  props: {
    buttonClasses: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onClick() {
      this.$emit("click");
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/scss/functions.scss";
@import "../../assets/scss/variables.scss";

.tgmag-btn {
  box-sizing: border-box;
  display: inline-block;
  font-size: $base-font-size * 2;
  padding: $base-padding * 1.5 $base-padding * 2.25;
  background-color: theme-color("action");
  color: $white;
  border-radius: 4px;
  font-weight: theme-weight("demi");
  cursor: pointer;
  transition: all 200ms ease;
  position: relative;

  .tgmag-btn__spinner {
    position: absolute;
    top: calc(50% - 20px);
    left: calc(50% - 20px);
  }

  &:hover,
  &:focus {
    background-color: lighten(theme-color("action"), 5%);
  }

  &--loading {
    color: transparent !important;
    cursor: wait;
    &:not([href]),
    &:not([tabindex]) {
      color: transparent !important;
    }
  }
  &--secondary {
    background-color: theme-color("secondary");
    &:hover,
    &:focus {
      background-color: lighten(theme-color("secondary"), 5%);
    }
  }
  &--accent {
    background-color: theme-color("accent");
    &:hover,
    &:focus {
      background-color: lighten(theme-color("accent"), 5%);
    }
  }
  &--action {
    background-color: theme-color("action");
    &:hover,
    &:focus {
      background-color: lighten(theme-color("action"), 5%);
    }
  }
  &--outline {
    background-color: transparent;
    color: theme-color("primary");
    border: 1px solid theme-color("primary");
    &:hover,
    &:focus {
      color: $white;
      background-color: lighten(theme-color("primary"), 5%);
    }
  }
  &--disabled {
    pointer-events: none;
    background-color: $input-button-inactive;
    border-color: $input-button-inactive;
    color: theme-color("support-2");
    cursor: not-allowed;
    &:not([href]),
    &:not([tabindex]) {
      color: theme-color("support-1") !important;
    }
    &:hover,
    &:focus {
      background-color: lighten(#f5f5f5, 2%);
    }
  }
  &--small {
    font-size: $base-font-size * 1.75;
    padding: $base-padding $base-padding * 1.75;
  }
  &--icon {
    [class^="icon-"],
    [class*=" icon-"] {
      padding-left: $base-padding;
      top: 1px;
      position: relative;
    }
  }
}
</style>
